"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeRowDataValues = void 0;
const makeRowDataValues = (value, enteredValueType, numberFormat, pattern) => {
    const rowDataValues = {
        userEnteredValue: {
            [enteredValueType]: value,
        },
    };
    if (numberFormat) {
        rowDataValues.userEnteredFormat = {
            numberFormat: {
                type: numberFormat,
                pattern,
            },
        };
    }
    return rowDataValues;
};
exports.makeRowDataValues = makeRowDataValues;
